<div class="animate__animated animate__flipInY animate__fast">
  <div class="animate__animated animate__infinite animate__vibrate thumbnail tile tile-danger text-center">
    <div class="tile-description">
      <i class="{{ ziroIcons.DELETE_BIG }}">
        <span class="font-bold">
          {{ 'tkey;dialogs.button.delete' | translate }}
        </span>
      </i>
      <div data-automation="service-tile-name">{{ serviceName() | translate }}</div>
      <div data-automation="service-tile-description">{{ description() | translate }}</div>
      <fieldset [disabled]="isDeleting()" class="mt-2">
        <ziro-button
          [cssClass]="'me-1'"
          [label]="'tkey;dialogs.button.cancel'"
          [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
          [buttonSize]="buttonSizes.SMALL"
          [isDisabled]="isDeleting()"
          (clicked)="onCancelClicked()"
          [attr.data-automation]="'delete-cancel'"
        ></ziro-button>
        <ziro-button
          [label]="'tkey;dialogs.button.delete'"
          [buttonStyle]="buttonStyles.OUTLINE_DANGER"
          [buttonSize]="buttonSizes.SMALL"
          [isPending]="isDeleting()"
          [iconPending]="ziroIcons.SAVING"
          [isDisabled]="isDeleting()"
          (clicked)="onConfirmClicked()"
          [attr.data-automation]="'delete-confirm'"
        ></ziro-button>
      </fieldset>
    </div>
  </div>
</div>
